import React from 'react';
import { pluralize } from 'utils/string_utils';

const ActionBarCounts = ({
  selectedCount,
  totalResults,
  filterIsActive,
  archivesIsActive,
}) => {
  const resultsString = pluralize(
    totalResults,
    `${t('contents.advanced_search.result')}`,
    `${t('contents.advanced_search.results')}`,
  );
  const itemsString = pluralize(
    selectedCount,
    `${t('contents.advanced_search.item')}`,
    `${t('contents.advanced_search.items')}`,
  );
  const archivesString = pluralize(
    totalResults,
    `${t('contents.advanced_search.item')}`,
    `${t('contents.advanced_search.items')}`,
  );

  const renderCounts = () => {
    if (!totalResults)
      return `${t('contents.advanced_search.no_results.heading')}.`;
    if (selectedCount) {
      if (filterIsActive)
        return `${totalResults} ${resultsString} ${t(
          'contents.advanced_search.found',
        )} (${selectedCount} ${t('contents.advanced_search.selected')}).`;
      return `${selectedCount} ${itemsString} ${t(
        'contents.advanced_search.selected',
      )}.`;
    }

    if (archivesIsActive)
      return `${totalResults} ${archivesString} ${t(
        'contents.advanced_search.archived',
      )}.`;

    return `${totalResults} ${resultsString} ${t(
      'contents.advanced_search.found',
    )}.`;
  };

  return <span>{renderCounts()}</span>;
};

export default ActionBarCounts;
